import React from 'react';
import { useNavigate } from 'react-router-dom';
import './RateLimitModal.css';

const RateLimitModal = ({ error, onClose }) => {
  const navigate = useNavigate();

  if (!error) return null;

  const handleLogin = () => {
    onClose();
    navigate('/login');
  };

  return (
    <div className="rate-limit-modal-overlay" onClick={onClose}>
      <div className="rate-limit-modal" onClick={(e) => e.stopPropagation()}>
        <div className="rate-limit-modal-header">
          <h2>⚠️ Rate Limit Exceeded</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>
        
        <div className="rate-limit-modal-body">
          <p className="rate-limit-message">{error.message || 'You have exceeded the rate limit. Please try again later.'}</p>
          
          {error.suggestion && (
            <div className="rate-limit-suggestion">
              <p>{error.suggestion}</p>
            </div>
          )}
          
          <div className="rate-limit-info">
            {error.currentLimit && (
              <div className="limit-item">
                <span className="limit-label">Current Limit:</span>
                <span className="limit-value">{error.currentLimit}</span>
              </div>
            )}
            {error.loginLimit && !error.isAuthenticated && (
              <div className="limit-item">
                <span className="limit-label">After Login:</span>
                <span className="limit-value highlight">{error.loginLimit}</span>
              </div>
            )}
            {error.premiumLimit && (
              <div className="limit-item">
                <span className="limit-label">Premium:</span>
                <span className="limit-value highlight">{error.premiumLimit}</span>
              </div>
            )}
          </div>
        </div>
        
        <div className="rate-limit-modal-footer">
          {!error.isAuthenticated && (
            <button className="btn-login" onClick={handleLogin}>
              Login to Increase Limit
            </button>
          )}
          <button className="btn-close" onClick={onClose}>
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default RateLimitModal;

